
import "./view-templates.js";

const timingViewRoot = document.getElementById("view-timing");
if (timingViewRoot && !timingViewRoot.firstElementChild) {
    timingViewRoot.innerHTML = window.__viewTimingTemplate || "";
}

const flowViewRoot = document.getElementById("view-flow");
if (flowViewRoot && !flowViewRoot.firstElementChild) {
    flowViewRoot.innerHTML = window.__viewFlowTemplate || "";
}

const skillsViewRoot = document.getElementById("view-skills");
if (skillsViewRoot && !skillsViewRoot.firstElementChild) {
    skillsViewRoot.innerHTML = window.__viewSkillsTemplate || "";
}

const settingsViewRoot = document.getElementById("view-settings");
if (settingsViewRoot && !settingsViewRoot.firstElementChild) {
    settingsViewRoot.innerHTML = window.__viewSettingsTemplate || "";
}

const controlSpecViewRoot = document.getElementById("view-control-spec");
if (controlSpecViewRoot && !controlSpecViewRoot.firstElementChild) {
    controlSpecViewRoot.innerHTML = window.__viewControlSpecTemplate || "";
}
